import React from 'react';
import { TablePagination, TablePaginationProps } from '@mui/material';
import styles from './pagination.module.scss';

const CustomPagination: React.FC<TablePaginationProps> = (props) => {
  return (
    <TablePagination
      {...props}
      component="div"
      className={`${styles.pagination} ${props.className || ''}`}
    />
  );
};

export default CustomPagination;
